<template>
  <transition name="modal">
    <div
      class="modal-mask"
      :class="{ 'modal-mask--full': fullScreen, 'color-mode--default': !colorMode, 'color-mode--dark': colorMode === 'dark', 'fit-to-content': fitToContent}"
    >
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header" v-if="!hideHeader">
            <slot name="header">
              <h2 v-if="title">{{title}}</h2>
              <button type="button" class="button__close" @click="$emit('close')" v-if="displayCloseButton">
                <i class="fas fa-times"></i>
                <span class="sr-only">{{ $t("common.closeButton") }}</span>
              </button>
            </slot>
          </div>

          <div class="modal__body text-center">
            <slot></slot>
          </div>

          <div class="modal-footer" v-if="!hideFooter">
            <slot name="footer">
              <button
                type="button"
                class="button button--primary button--cta"
                @click="$emit('close')"
              >{{ $t("common.backButton") }}</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  component: "Modal",
  props: {
    title: {
      type: String
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    colorMode: {
      type: String,
      default: "default"
    },
    fitToContent: {type: Boolean, default: false},
     hideHeader: {
      type: Boolean, default: false
    },
    hideFooter: {
      type: Boolean, default: false
    },
    displayCloseButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    bindKeys(e) {
      let keyCode = e.keyCode ? e.keyCode : '';
      let keyName = e.key ? e.key : e.code;

      if(String(keyName).toLowerCase() == 'escape')
        this.$emit('close');
    }
  },
  mounted() {
    window.addEventListener('keyup', this.bindKeys);
  },
  beforeUnmount: function () {
    window.removeEventListener('keyup', this.bindKeys);
  }
};
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "~@/assets/scss/abstracts/_variables.scss" as *;
.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  &.modal-bg--red .modal-container {
    background: $red;
    color: $white;
  }
}

.button__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 1000;
}

.modal-container {
  width: 95%;
  position: relative;
  max-width: 800px;
  margin: 0px auto;
  padding: 20px 30px;
  padding: .8rem .5rem;
  background-color: $greyLight;
  transition: all 0.3s ease;
  .modal-container {
    background-color: color.adjust($greyLight, $lightness: -0.7%) !important;
  }
  @media screen and (min-width: $breakpoint-md) {
    padding: 1.2rem 1.5rem;
  }
}

.modal__header {
  display: flex;
  margin-top: 0;
}
.modal__body {
  margin: 1rem;
  overflow: auto;
  max-height: 70vh;
  .button {
    margin: 0.5rem auto;
    display: inline-block;
    max-width: 600px;
    width: 80%;
  }
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-mask--full {
  .modal-container {
    padding: 0;
    background-color: transparent;
    max-width: 1200px;
  }
  .modal-body {
    margin: 0;
    padding: 0;
  }
  .button__close {
    color: #fff;
    font-size: 1.3rem;
    padding: 0;
    position: fixed;
    position: absolute;
    right: 0rem;
    top: -0.8rem;
    z-index: 99;
    background: #000;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      margin-right: 0;
    }
  }
  .modal__body {
    max-height: 100%;
  }
  .modal-footer {
    display: none;
  }
}
.modal-header {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 1.1rem;
    font-family: $fontPrimaryBold;
    text-align: center;
  }
}

.fit-to-content {
  .modal-container {
    padding: 0;
  }
  .modal__body {
    margin: 0;
    padding: 0;
  }
  .modal-footer {
    display: none !important;
  }
  .button__close {
    background-color: #fff;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    position: absolute;
    top: -1rem;
    right: -1rem;
  }
}
.color-mode--dark {
  &.modal-mask {
    background-color: rgba($greyBlueDark, 0.5);
  }

  .modal-container {
    background: #fff !important;
  }
}
</style>
